import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledImg = styled.img`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const HeroWrapper = styled.div`
  height: 120px;
  ${props => props.theme.query.md} {
    height: 410px;
  }
  position: relative;
  overflow: hidden;
`;

const propTypes = { defaultHeroImage: PropTypes.string };

const DefaultHeroImage = ({ defaultHeroImage }) => {
  return (
    <HeroWrapper>
      <StyledImg src={defaultHeroImage} />
    </HeroWrapper>
  );
};

DefaultHeroImage.propTypes = propTypes;
export default DefaultHeroImage;
